import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "global-unread-badge" }

import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { mainStore } from '@/stores/mainStore';
import { useMensajesUnreadStore } from '@/stores/mensajesUnread';
import { IonApp, IonRouterOutlet, IonLoading, IonIcon } from '@ionic/vue';
import { mailOutline } from 'ionicons/icons';
import InstallAppBanner from '@/components/InstallAppBanner.vue';
import { useInstallAppBanner } from '@/composables/useInstallAppBanner';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainStoreInstance = mainStore();
const { visible: showInstallBanner } = useInstallAppBanner();
const router = useRouter();
const unreadStore = useMensajesUnreadStore();
const { count: unreadCount } = storeToRefs(unreadStore);

const tokenPresent = ref(!!localStorage.getItem('token'));
const lastTokenPresent = ref(tokenPresent.value);

const showUnreadBubble = computed(
  () => tokenPresent.value && unreadCount.value > 0
);

const unreadBadgeText = computed(() => {
  const n = unreadCount.value;
  if (n > 99) return '99+';
  return String(n);
});

const goMensajes = () => {
  void router.push('/tabs/mensajes');
};

router.afterEach(() => {
  tokenPresent.value = !!localStorage.getItem('token');
  if (tokenPresent.value === lastTokenPresent.value) {
    return;
  }
  if (tokenPresent.value) {
    unreadStore.startPolling();
  } else {
    unreadStore.resetAndStop();
  }
  lastTokenPresent.value = tokenPresent.value;
});

onMounted(() => {
  if (localStorage.getItem('token')) {
    unreadStore.startPolling();
  }
  lastTokenPresent.value = !!localStorage.getItem('token');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass({ 'has-install-banner': _unref(showInstallBanner) })
  }, {
    default: _withCtx(() => [
      _createVNode(InstallAppBanner),
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(mainStoreInstance).$state.loading.show,
        message: _unref(mainStoreInstance).$state.loading.message
      }, null, 8, ["is-open", "message"]),
      _createVNode(_unref(IonRouterOutlet)),
      _withDirectives(_createElementVNode("button", {
        type: "button",
        class: "global-unread-bubble",
        "aria-label": "Mensajes sin leer",
        onClick: goMensajes
      }, [
        _createVNode(_unref(IonIcon), { icon: _unref(mailOutline) }, null, 8, ["icon"]),
        _createElementVNode("span", _hoisted_1, _toDisplayString(unreadBadgeText.value), 1)
      ], 512), [
        [_vShow, showUnreadBubble.value]
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})